// A unit the backend refused to a production user: a 404 whose body says which
// rule refused it (see BaseActualViewSet._refusal in the backend).

// The sentence for it, the same in the viewer's banner and in a toast.
export function refusalText(t, refusal) {
    const line = refusal?.production_line?.name
    if (refusal?.code == "other_line" && line) return t("refused_other_line").replace("{line}", line)
    if (refusal?.code == "other_line") return t("refused_unknown")
    if (refusal?.code == "batch_hidden") return t("refused_batch_hidden")
    if (refusal?.code == "project_archived") return t("refused_project_archived")
    return t("refused_unknown")
}

// Whether this account may move itself to that line: the rule
// select_station_view applies on the backend. Its own home line is always
// allowed, the others need a manager role or can_select_production_line.
export function canChangeLine(auth, line_uuid) {
    if (!auth?.can_select_station) return false
    if (line_uuid && line_uuid == auth.production_line) return true
    return !!(auth.company_admin || auth.company_manager || auth.can_select_production_line)
}
